import { checkFingerPrintDetails } from '../utils/fingerPrint.js';

// load fingerprint JS before any api call
const setBrowserFingerPrint = isFingerPrintLoaded => store => next => async action => {
  if (action && typeof action.then === 'function' && !isFingerPrintLoaded) {
    await checkFingerPrintDetails();
    isFingerPrintLoaded = true;
  }
  return next(action);
};

export default setBrowserFingerPrint;
